import {
  QuestionListSection,
  QuestionSummaryDashboard,
} from '@exam-management/question-creation-task-details';
import { Flex } from '@shared/components';

export default function QuestionCreationQuestionList() {
  return (
    <Flex
      sx={{
        flexDirection: 'column',
        flex: 1,
        p: (theme) => theme.spacing(6),
        gap: (theme) => theme.spacing(6),
      }}
    >
      <QuestionSummaryDashboard />
      <QuestionListSection />
    </Flex>
  );
}
